export default __webpack_public_path__ + "static/media/jntua-emblem-logo.6563a949.png";